var map = {
	"./aws-cognito-google-sso.md": "4b11",
	"./building-a-nativescript-travel-planner.md": "c5de",
	"./building-mvps-for-free.md": "1cca",
	"./bye-expensive-vector-storage-hello-s3-vectors.md": "869d",
	"./client-side-rendering-search-engine-optimisation.md": "25d6",
	"./event-sourcing-introduction.md": "319b",
	"./from-tech-tests-to-tiny-urls.md": "9ff0",
	"./langchain-chain-vs-agents.md": "a42a",
	"./multi-agent-architecture-in-aws.md": "1ca3",
	"./releasing-a-mobile-app.md": "2450",
	"./revisiting-eco-infra.md": "e991",
	"./spec-driven-development-with-ai-agents-a-practical-guide-for-real-systems.md": "4efc",
	"./terraform-for-scale-ups.md": "0728",
	"./vibe-coding-a-markdown-blog.md": "0327"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "233d";